import { ShoppingListItem } from "./types";
import { config } from "./config";

const apiRoot = config.apiBaseUrl.replace(/\/$/, "");

function authHeaders(): Record<string, string> {
  const token = localStorage.getItem("access_token") ?? localStorage.getItem("id_token");
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
}

async function request<T>(url: string, options: RequestInit): Promise<T> {
  const response = await fetch(`${apiRoot}${url}`, {
    headers: {
      "Content-Type": "application/json",
      ...authHeaders(),
      ...options.headers
    },
    ...options
  });

  if (!response.ok) {
    const text = await response.text();
    const err = new Error(text || response.statusText) as Error & { status?: number };
    err.status = response.status;
    throw err;
  }

  // Handle empty bodies (e.g., 204) without throwing JSON parse errors.
  const raw = await response.text();
  if (!raw) {
    return undefined as T;
  }

  return JSON.parse(raw) as T;
}

export function fetchItems(): Promise<ShoppingListItem[]> {
  return request("/items", { method: "GET" });
}

export function fetchItem(id: string): Promise<ShoppingListItem> {
  return request(`/items/${id}`, { method: "GET" });
}

export function createItem(payload: Omit<ShoppingListItem, "id" | "createdAt" | "updatedAt">): Promise<ShoppingListItem> {
  return request("/items", { method: "POST", body: JSON.stringify(payload) });
}

export function updateItem(id: string, payload: Omit<ShoppingListItem, "id" | "createdAt" | "updatedAt">): Promise<ShoppingListItem> {
  return request(`/items/${id}`, { method: "PUT", body: JSON.stringify(payload) });
}

export function deleteItem(id: string): Promise<void> {
  return request(`/items/${id}`, { method: "DELETE" });
}
